/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Progress/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import BookingLoading from './BookingLoading/index'
import Ongoing from './Ongoing/index'
import React from 'react'
import ReadyToSubmit from './ReadyToSubmit/index'
import Welcome from './Welcome/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Progress({
  children,
  viewPath = "/App/Form/Progress"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Welcome'
  return (<React.Fragment
>
<div
  data-testid="Progress.TopBar"
  data-view-path={viewPath}
 className={`views-block ${styles.TopBar}`}
>
<fromFlow.When is={flowValue === 'Welcome'}>
<Welcome
  viewPath={`${viewPath}/Welcome`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Ongoing'}>
<Ongoing
  viewPath={`${viewPath}/Ongoing`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ReadyToSubmit'}>
<ReadyToSubmit
  viewPath={`${viewPath}/ReadyToSubmit`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'BookingLoading'}>
<BookingLoading
  viewPath={`${viewPath}/BookingLoading`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}